@if (isOpen) {
<div class="fixed inset-0 z-500 flex items-center justify-center p-4" data-cy="modal-overlay">
  <!-- Overlay -->
  <div class="fixed inset-0 bg-gray-900 opacity-50 cursor-pointer" (click)="onClose()"></div>

  <!-- Modal Content -->
  <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-lg w-full p-6 relative z-10">
    <!-- Header -->
    <div class="flex justify-between items-center pb-3 border-b border-gray-200 dark:border-gray-700">
      <h2 class="text-xl font-semibold text-gray-800 dark:text-white">{{ title }}</h2>
      <button
        (click)="onClose()"
        class="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 cursor-pointer"
        [attr.data-cy]="closeButtonDataCy"
      >
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Body (Content Projection) -->
    <div class="py-4">
      <ng-content></ng-content>
    </div>

    <!-- Footer (Optional Content Projection for buttons) -->
    <div class="pt-4 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-2">
      <ng-content select="[modal-footer]"></ng-content>
    </div>
  </div>
</div>
}
